<template>
    <v-navigation-drawer
        v-model="mainDrawer"
        fixed
        temporary
        right
        flat
        :width="windowWidth"
        class="search-filters-mobile"
        :style="{'overflow-y': additionalDrawer || searchFilterDrawerState ? 'hidden': 'auto'}"
        ref="mainDrawer"
    >
        <v-container fluid>
            <v-layout row wrap>
                <v-flex xs12>
                    <a @click.prevent="mainDrawer = false" class="search-filters-back">
                        {{ 'back' | translation }}
                    </a>

                    <v-divider></v-divider>
                </v-flex>

                <v-flex xs12>
                    <v-card
                        flat
                        @click="showAdditionalDrawer(drawerTypes.categories)"
                        class="search-filters pa-2 d-flex align-center bordered-filter"
                    >
                        <div>
                            <p class="title ma-0 search-filter-title">{{ 'category' | translation }}</p>
                            <p class="ma-0 primary--text">{{currentCategory}}</p>
                        </div>
                        <v-spacer></v-spacer>
                        <span class="text-xs-right">
                            <v-icon large>keyboard_arrow_right</v-icon>
                        </span>
                    </v-card>
                </v-flex>

                <v-flex xs12 mt-2>
                    <v-card
                        flat
                        @click="showAdditionalDrawer(drawerTypes.ordering)"
                        class="search-filters bordered-filter pa-2 d-flex align-center"
                    >
                        <div>
                            <p class="title ma-0 search-filter-title">{{ 'sort by' | translation }}</p>
                            <p class="ma-0 primary--text">{{currentSorting}}</p>
                        </div>
                        <v-spacer></v-spacer>
                        <span class="text-xs-right">
                            <v-icon large>keyboard_arrow_right</v-icon>
                        </span>
                    </v-card>
                </v-flex>

                <v-flex xs12>
                    <p class="title mt-3 mb-1 attribute-search-filters-title">{{ 'Refine your search' | translation }}</p>
                </v-flex>

                <v-flex xs12 class="search-filter-price">
                    <v-card
                        flat
                        @click="showAdditionalDrawer(drawerTypes.price)"
                        class="search-filters pa-2 d-flex align-center bordered-filter"
                    >
                        <div>
                            <p class="title ma-0">{{ 'price' | translation }}</p>
                            <p class="ma-0 primary--text">
                                {{currentPrices.priceMin}}
                                <template v-if="currentPrices.priceMax > 0 && !currentPrices.priceMin > 0">0</template>
                                <template v-if="currentPrices.priceMax > 0">-</template>
                                {{currentPrices.priceMax}}
                            </p>
                        </div>
                        <v-spacer></v-spacer>
                        <span class="text-xs-right">
                            <v-icon large>keyboard_arrow_right</v-icon>
                        </span>
                    </v-card>
                </v-flex>

                <v-flex xs12>
                    <search-filters
                        class="search-filters bordered-filter"
                        :search-results="searchResults"
                        :drawer-offset="scrollTop"
                        :internalDrawerState.sync="searchFilterDrawerState"
                    ></search-filters>
                </v-flex>
            </v-layout>

            <v-navigation-drawer
                v-model="additionalDrawer"
                fixed
                temporary
                right
                flat
                :width="windowWidth"
                :style="{top: scrollTop + 'px'}"
            >
                <v-container fluid>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <a @click.prevent="hideAdditionalDrawer()">
                                {{ 'back' | translation }}
                            </a>

                            <v-divider></v-divider>
                        </v-flex>

                        <v-flex xs12>
                            <categories-filter
                                v-show="additionalType === drawerTypes.categories"
                                :parentsList="searchResults.parentsList"
                                :categories="categoriesList"
                                :categoriesFacet="searchResults.categoriesFacet"
                                v-model="currentCategory"
                                class="categories-filter"
                            ></categories-filter>

                            <sorting-selector
                                v-show="additionalType === drawerTypes.ordering"
                                v-model="currentSorting"
                            ></sorting-selector>

                            <price-filter
                                v-show="additionalType === drawerTypes.price"
                                v-model="currentPrices"
                            ></price-filter>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-navigation-drawer>
        </v-container>
    </v-navigation-drawer>
</template>

<style>
    .search-filters-mobile .bordered-filter {
        border-top: 1px solid;
        border-bottom: 1px solid;
        border-left: 1px solid;
        border-right: 1px solid;
        border-color: #949494 !important;
        border-radius: 0;
    }

    .search-filters-mobile .bordered-filter .attribute-type:not(:last-child) {
        border-bottom: 1px solid;
        border-color: #949494 !important;
        border-radius: 0;
    }
</style>

<script>
    import SearchFilters from './SearchFilters';
    import CategoriesFilter from './CategoriesFilter';
    import SortingSelector from './SortingSelector';
    import PriceFilter from './PriceFilter';

    export default {
        name: 'MobileSearchFilters',
        components: {
            SearchFilters,
            CategoriesFilter,
            SortingSelector,
            PriceFilter,
        },
        props: [
            'searchResults',
            'value',
        ],
        data() {
            return {
                additionalDrawer: false,
                drawerTypes: {
                    categories: 'categories',
                    ordering: 'ordering',
                    price: 'price',
                },
                additionalType: null,
                windowWidth: window.innerWidth,
                currentSorting: null,
                currentPrices: {},
                currentCategory: null,
                searchFilterDrawerState: false,
                scrollTop: 0,
            };
        },
        computed: {
            mainDrawer: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                },
            },
            categoriesList() {
                return this.searchResults.categories;
            },
        },
        methods: {
            showAdditionalDrawer(type) {
                this.additionalType = type;
                this.additionalDrawer = true;
            },
            hideAdditionalDrawer() {
                this.additionalType = null;
                this.additionalDrawer = false;
            },
        },
        watch: {
            searchFilterDrawerState() {
                this.scrollTop = this.$refs.mainDrawer.$el.scrollTop;
            },
            additionalDrawer() {
                this.scrollTop = this.$refs.mainDrawer.$el.scrollTop;
            },
        },
    };
</script>